export const header = ["dashboard", "offices", "folders", "projects", "users", "organisations"];
export const userSideBarHeader = ["dashboard", "projects"];
